<template>
  <div>
    <div class="columns">
      <div class="column is-flex content-center is-flex-column">
          <h1 class="title f-24">{{linkedAccount.account}}</h1>
          <h6 class="subtitle f-12">Sender</h6>
      </div>
      <div class="column is-flex content-center is-flex-column">
        <h1 class="title f-24">{{tokenBalance}}</h1>
        <h6 class="subtitle f-12">{{symbol}} Balance</h6>
      </div>
    </div>
    <text-field label="Receiver" v-model="to" />
    <div class="columns">
        <div class="column is-8">
          <div class="field ">
          <div class="is-flex space-between">
            <label class="txt-14">Amount</label>
            <label class="txt-14">{{percentage}}%</label>
          </div>
          <div class="control">
            <text-field label="" v-model="quantity" />
          </div>
          <div class="control">
            <label class="txt-14"></label>
            <input type="range" :value="percentage" @change="updateQty" min="1" max="100" class="slider">
          </div>
        </div>
        </div>
        <div class="column">
          <field label="Token">
            <div class="control">
              <v-select v-model="symbol" :options="tokenList"></v-select>
            </div>
          </field>
        </div>
    </div>
    <field label="Memo">
      <div class="control">
        <textarea class="textarea" v-model="memo"></textarea>
      </div>
    </field>
    <p v-if="lastTx" class="has-background-white">
      <a class="button is-primary is-fullwidth is-text is-outlined" :href="'https://eosq.app/tx/'+ lastTx.transaction_id" target="_blank">{{$t("wallet.viewTransaction")}}</a>
    </p>
  </div>
</template>

<script>

import TextField from '@/components/general/text-field'
import Field from '@/components/general/field'
import {mapState, mapMutations} from 'vuex'
import vSelect from 'vue-select'

export default {
  components: { Field, TextField, vSelect },
  data () {
    return {
      percentage: 0
    }
  },
  mounted () {
    this.$store.commit('wallet/setSendSymbol', this.activeToken)
  },
  methods: {
    ...mapMutations('wallet', ['setTokenReceiver', 'setSendQuantity', 'setSendSymbol', 'setSendMemo']),
    updatePercentage () {
      this.percentage = (this.quantity / this.getBalance * 100).toFixed(2)
    },
    updateAccount () {
      if (this.supportedTokens) {
        const t = this.supportedTokens.filter((t) => {
          return t.symbol === this.symbol
        }).shift()
        this.$store.commit('wallet/setSendTokenAccount', t.account)
      }
    },
    updateQty (e) {
      this.percentage = e ? e.target.value : this.percentage
      const balance = this.getBalance
      if (balance > 0) {
        const qty = ((balance * this.percentage) / 100).toFixed(4)
        this.$store.commit('wallet/setSendQuantity', qty)
      }
    }
  },
  watch: {
    symbol () {
      this.updateAccount()
      this.updateQty()
      this.updatePercentage()
    }
  },
  computed: {
    ...mapState('wallet', ['supportedTokens', 'send', 'activeToken', 'tokens', 'linkedAccount']),
    ...mapState('sigproviders', ['lastTx']),
    tokenList () {
      return this.supportedTokens.map(t => {
        return t.symbol
      })
    },
    getBalance () {
      if (this.tokens) {
        const t = this.tokens.filter(t => {
          return t.symbol === this.symbol
        }).shift()
        return t ? parseFloat(t.balance) : 0
      }
      return 0
    },
    tokenBalance () {
      const balance = this.getBalance
      let d = 2
      if (balance < 1) {
        d = 4
      }

      return parseFloat(this.getBalance).toLocaleString(undefined, {minimumFractionDigits: d, maximumFractionDigits: d})
    },
    to: {
      get () {
        return this.send.to
      },
      set (val) {
        this.setTokenReceiver(val)
      }
    },
    quantity: {
      get () {
        return this.send.quantity
      },
      set (val) {
        if (val <= this.getBalance) {
          this.setSendQuantity(parseFloat(val).toFixed(4))
          this.updatePercentage()
        }
      }
    },
    symbol: {
      get () {
        return this.send.symbol
      },
      set (val) {
        this.setSendSymbol(val)
      }
    },
    memo: {
      get () {
        return this.send.memo
      },
      set (val) {
        this.setSendMemo(val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/styles/defaults.scss';
  .field {
    &.is-horizontal{
      margin-bottom: 0 !important;
    }
  }

  .v-select {
    width: 100%;
    // margin-bottom: 0.7rem;
  }

  /deep/ .v-select li a {
    padding: 0.7rem
  }

  /deep/ .v-select .dropdown-toggle {
    width: 100%;
    height: 2.5rem;
    margin-bottom: 0.2em;
    border-color: #dbdbdb;
    background: #fff;
    font-size: 14px;
  }

  /deep/ .v-select .dropdown-toggle:hover {
    border-color: #b5b5b5;
  }

  /deep/ .v-select .open-indicator::before {
    content: "";
    z-index: 4;
    position: absolute;
    width: 0px;
    height: 0px;
    border-bottom: 6px solid black;
    border-right: 6px solid transparent;
    border-top: 6px solid transparent;
    border-left: 6px solid transparent;
    top: 18%;
    right: 1rem;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    transform-origin: bottom center;
    transition: all .15s cubic-bezier(1,-.115,.975,.855);
    transition-timing-function: cubic-bezier(1,-.115,.975,.855);
  }

  /deep/ .v-select .open-indicator::after {
    content: "";
    z-index: 4;
    position: absolute;
    width: 0px;
    height: 0px;
    border-top: 6px solid black;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid transparent;
    top: 52%;
    right: 1rem;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    transform-origin: top center;
    transition: all .15s cubic-bezier(1,-.115,.975,.855);
    transition-timing-function: cubic-bezier(1,-.115,.975,.855);
  }

  /deep/ .v-select.open .open-indicator::before {
    transform: rotate(180deg);
  }

  /deep/ .v-select.open .open-indicator::after {
    transform: rotate(180deg);
    opacity: 0.0;
  }

  /deep/ .v-select .clear {
    display: none;
  }

  .slider {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 10px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
  margin-top: 10px;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: $primary;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: $primary;
  cursor: pointer;
}

  @media screen and (max-width: $tablet) {
    .field {
      &.is-horizontal{
        margin-bottom: 1.5rem !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wallet/send.vue